const AD_TENANT_ID_PLACEHOLDER_KEY = '{{AD_TENANT_ID}}';

export const replaceTenantIdPlaceholder = (string = '') => string
  .replace(AD_TENANT_ID_PLACEHOLDER_KEY, window.AD_TENANT_ID || '');
